import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Shield({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Shield.Outline {...props} /> : <Shield.Solid {...props} />;
}

Shield.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M12.4889 22.0122C12.365 22.0122 12.2412 21.9838 12.1295 21.9259L8.52837 20.0618C7.50653 19.5323 6.70718 18.9381 6.083 18.2458C4.71686 16.7317 3.95678 14.7882 3.9447 12.7721L3.90241 6.13647C3.89738 5.37063 4.39169 4.68324 5.13063 4.42436L11.7429 2.119C12.1355 1.97877 12.5734 1.97681 12.9731 2.11213L19.6105 4.33905C20.3535 4.58714 20.8559 5.26963 20.8599 6.03449L20.9022 12.675C20.9153 14.6882 20.1813 16.6396 18.8363 18.1703C18.2192 18.8724 17.4269 19.4754 16.4151 20.0147L12.8463 21.921C12.7355 21.9808 12.6127 22.0112 12.4889 22.0122Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
        <path
          d="M11.7215 14.3331C11.5282 14.3341 11.3349 14.2645 11.1859 14.1213L9.26911 12.2778C8.97313 11.9915 8.97011 11.5267 9.26307 11.2384C9.55603 10.9491 10.0342 10.9462 10.3312 11.2315L11.7104 12.5573L15.078 9.237C15.372 8.94772 15.8501 8.94478 16.1461 9.23013C16.4431 9.51647 16.4461 9.98225 16.1532 10.2696L12.2541 14.1144C12.1071 14.2596 11.9148 14.3321 11.7215 14.3331Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Shield.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M12.7374 22.0122C12.6136 22.0122 12.4897 21.9838 12.378 21.9259L8.7769 20.0618C7.75506 19.5323 6.95572 18.9381 6.33154 18.2458C4.9654 16.7317 4.20531 14.7882 4.19323 12.7721L4.15095 6.13647C4.14591 5.37063 4.64022 4.68324 5.37917 4.42436L11.9914 2.119C12.384 1.97877 12.822 1.97681 13.2216 2.11213L19.8591 4.33905C20.602 4.58714 21.1044 5.26963 21.1084 6.03449L21.1507 12.675C21.1638 14.6882 20.4299 16.6396 19.0849 18.1703C18.4677 18.8724 17.6754 19.4754 16.6637 20.0147L13.0948 21.921C12.9841 21.9808 12.8612 22.0112 12.7374 22.0122Z"
          className="icon-secondary"
        />
        <path
          d="M11.9701 14.3331C11.7768 14.3341 11.5835 14.2645 11.4345 14.1213L9.51765 12.2778C9.22167 11.9915 9.21865 11.5267 9.51161 11.2384C9.80457 10.9491 10.2828 10.9462 10.5798 11.2315L11.959 12.5573L15.3265 9.237C15.6205 8.94772 16.0987 8.94478 16.3947 9.23013C16.6917 9.51647 16.6947 9.98225 16.4017 10.2696L12.5026 14.1144C12.3556 14.2596 12.1634 14.3321 11.9701 14.3331Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
